export default __webpack_public_path__ + "postMock-1747989021042.html";